import React, { useEffect } from 'react';
import Header from '../components/Layout/Header/Header';
import Footer from '../components/Layout/Footer/Footer';
import AboutUs from '../components/AboutUs/AboutUs';
import SEO from '../components/SEO';
import { useScrollState } from '../stores/scrollStore';
import { useLoadingScreen } from '../stores/modalStore';

const AboutUsPage: React.FC = () => {
  const { isScrolled, scrollProgress, throttledUpdateScrollState } = useScrollState();
  const { setVisible: setShowLoading } = useLoadingScreen();

  // Hide loading screen for non-Home pages
  useEffect(() => {
    setShowLoading(false);
  }, [setShowLoading]);

  useEffect(() => {
    // Use throttled scroll handler for native scrolling
    const handleScroll = () => {
      throttledUpdateScrollState(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [throttledUpdateScrollState]);

  return (
    <>
      <SEO 
        title="About Cinquity | Leading AI-Driven eCOA Platform"
        description="Learn about Cinquity's mission to transform clinical trials through AI-powered eCOA solutions. Discover our team, technology, and commitment to accelerating pharmaceutical innovation."
        keywords="about Cinquity, eCOA company, clinical trial technology, AI healthcare, pharmaceutical innovation, clinical data solutions, healthcare technology team"
      />
      <Header isScrolled={isScrolled} scrollProgress={scrollProgress} />
      <div className="about-page-container">
        <AboutUs />
        <Footer />
      </div>
    </>
  );
};

export default AboutUsPage;
